import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import userRoutes from '../../../components/user/userRoutes';

const update = createAsyncThunk(
  'thunk/user/update',
  async (arg, thunkAPI) => {
    const response = await apiFetch(userRoutes.api.generate.update(arg?.id), {
      body: arg?.data,
      method: 'POST',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
